var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDolly(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16.3,27.8c-2.3,0-4.2,1.9-4.2,4.2c0,2.3,1.9,4.2,4.2,4.2c2.3,0,4.2-1.9,4.2-4.2 C20.5,29.7,18.6,27.8,16.3,27.8z M18.6,32.3c-0.2,1.3-1.5,2.2-2.8,1.9s-2.2-1.5-1.9-2.8c0.2-1.3,1.5-2.2,2.8-1.9S18.9,31,18.6,32.3 z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#505050",
    cx: 16.3,
    cy: 31.9,
    r: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M16.3,7.6h-4.8c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6h4.2v17.9C13,27,10.9,29.3,10.9,32 c0.2,2.5,2,4.5,4.4,4.9c2.9,0.5,5.7-1.4,6.3-4.3h11.9c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6h-2.4v-8.9 c0-0.3-0.3-0.6-0.6-0.6h-1.7V13c0-0.3-0.3-0.6-0.6-0.6h-8.4c-0.3,0-0.6,0.3-0.6,0.6v9.5c0,0.3,0.3,0.6,0.6,0.6h1.8v8.3 c-0.3-2.5-2.2-4.4-4.7-4.7V8.2C16.9,7.9,16.6,7.6,16.3,7.6z M23.4,13.6h1.2V16h-1.2V13.6z M20.4,21.9v-8.3h1.8v2.9 c0,0.3,0.3,0.6,0.6,0.6h2.4c0.3,0,0.6-0.3,0.6-0.6v-2.9h1.8v8.3H20.4z M27,23.1v2.4h-1.2v-2.4H27z M22.8,23.1h1.8v3 c0,0.3,0.3,0.5,0.6,0.5h2.4c0.3,0,0.6-0.2,0.6-0.5v-3h1.7v8.3h-7.1V23.1z M20.5,32c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2 c0-2.3,1.9-4.2,4.2-4.2C18.6,27.8,20.5,29.7,20.5,32z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.4,
    y: 13.6,
    fill: "#C9C9C9",
    width: 1.2,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.8,
    y: 23.1,
    fill: "#C9C9C9",
    width: 1.2,
    height: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8B85D",
    d: "M27.6,13.6h-1.8v2.9c0,0.3-0.3,0.6-0.6,0.6h-2.4c-0.3,0-0.6-0.3-0.6-0.6v-2.9h-1.8v8.3h7.2V13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8B85D",
    d: "M22.8,31.4h7.1v-8.3h-1.7v3c0,0.3-0.3,0.5-0.6,0.5h-2.4c-0.3,0-0.6-0.2-0.6-0.5v-3h-1.8V31.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDolly);
export default __webpack_public_path__ + "static/media/dolly.155f9ff549bec5177e615e10149a4e4f.svg";
export { ForwardRef as ReactComponent };